/**
 * Retires a catalog entry: it is kept, so whatever names it still reads, and it
 * drops out of the pickers. Restoring it is one click, so this only asks once,
 * and says what uses it. A reason it cannot be retired disables the button and
 * is shown in its place.
 */
export default function RetireCatalogEntryForm({
  name,
  message,
  blocked,
  confirmLabel,
  saving,
  error,
  onConfirm,
  onCancel,
}: {
  name: string
  message: string
  blocked?: string
  confirmLabel: string
  saving: boolean
  error: string | null
  onConfirm: () => void
  onCancel: () => void
}) {
  return (
    <form
      className="flex flex-col gap-3 rounded-surface border border-line bg-canvas p-3"
      aria-label={`Retire ${name}`}
      onSubmit={(event) => {
        event.preventDefault()
        if (!saving && !blocked) onConfirm()
      }}
    >
      <p className="text-small">{blocked ?? message}</p>
      {error && (
        <p role="alert" className="text-caption font-semibold text-error">
          {error}
        </p>
      )}
      <div className="flex gap-2">
        <button
          type="submit"
          disabled={saving || Boolean(blocked)}
          className="flex min-h-11 items-center justify-center rounded-control bg-primary px-4 text-small font-bold text-primary-ink hover:bg-primary-hover disabled:opacity-40"
        >
          {saving ? 'Retiring…' : confirmLabel}
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="flex min-h-11 items-center justify-center rounded-control px-4 text-small font-bold text-ink-muted hover:bg-surface-2"
        >
          Cancel
        </button>
      </div>
    </form>
  )
}
